import script from "./Text.vue?vue&type=script&setup=true&lang=ts"
export * from "./Text.vue?vue&type=script&setup=true&lang=ts"

import "./Text.vue?vue&type=style&index=0&id=255f384b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255f384b"]])

export default __exports__